import GoogleTagManagerHelper from '@tracking/gtm-helper';

export const clickTracking = (eventLabel: string, eventAction: string, eventName: string) => {
  GoogleTagManagerHelper.ga4Event(eventName, { section_reference: eventLabel });
};
